// Gemensamt dragspelsbeteende för FAQ-listan och topplistorna. Växlar bara aria-expanded
// på knappen och hidden på panelen den pekar ut med aria-controls — utseendet ligger i scss.

export interface AccordionSelectors {
  item: string;
  trigger: string;
}

export function setAccordionItemOpen(
  item: HTMLElement,
  open: boolean,
  selectors: AccordionSelectors,
): void {
  const trigger = item.querySelector<HTMLButtonElement>(selectors.trigger);
  const panelId = trigger?.getAttribute("aria-controls");
  const panel = panelId ? document.getElementById(panelId) : null;

  if (!trigger || !panel) {
    return;
  }

  trigger.setAttribute("aria-expanded", String(open));
  panel.hidden = !open;
}

/** Kopplar klickhantering på en lista. Raderna öppnas och stängs oberoende av varandra. */
export function initAccordion(
  list: HTMLElement,
  selectors: AccordionSelectors,
): void {
  list.addEventListener("click", (event) => {
    const trigger = (event.target as HTMLElement).closest<HTMLButtonElement>(
      selectors.trigger,
    );
    const item = trigger?.closest<HTMLElement>(selectors.item);

    if (!trigger || !item || !list.contains(item)) {
      return;
    }

    setAccordionItemOpen(
      item,
      trigger.getAttribute("aria-expanded") !== "true",
      selectors,
    );
  });
}
